(() => {
  const prompt = document.getElementById('hk-language-prompt');
  if (!prompt || prompt.dataset.initialized) return;
  prompt.dataset.initialized = 'true';
  const previewTest = prompt.dataset.preview === 'true' && new URL(window.location.href).searchParams.get('hk_language_test') === '1';
  const key = 'hobbykort-language-prompt-v1';
  const stores = () => {
    const result = [];
    for (const name of ['localStorage', 'sessionStorage']) {
      try { result.push(window[name]); } catch (_) {}
    }
    return result;
  };
  const swedishKey = 'hobbykort-explicit-swedish-v1';
  const attemptKey = 'hobbykort-explicit-swedish-attempt-v1';
  const active = key => stores().some(storage => {
    try { return Number(storage.getItem(key)) > Date.now(); } catch (_) { return false; }
  });
  const remembered = () => active(key);
  const clear = key => stores().forEach(storage => { try { storage.removeItem(key); } catch (_) {} });
  const saveSwedish = () => stores().forEach(storage => { try { storage.setItem(swedishKey, String(Date.now() + 30 * 86400000)); } catch (_) {} });
  if (document.documentElement.lang.toLowerCase().split('-')[0] === 'sv') clear(attemptKey);
  const remember = () => {
    for (const storage of stores()) {
      try { storage.setItem(key, String(Date.now() + 30 * 86400000)); } catch (_) {}
    }
  };
  const dismiss = () => { clear(swedishKey); remember(); prompt.hidden = true; };
  const form = prompt.querySelector('form');
  const rememberManual = event => {
    const selected = event.target.closest?.('form');
    if (selected && selected !== form) {
      const language = selected.querySelector('[name="language_code"]');
      if (language) {
        dismiss();
        if (language.value === 'sv') saveSwedish();
      }
    }
  };
  document.addEventListener('change', rememberManual, true);
  document.addEventListener('submit', rememberManual, true);
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'en' || !form || (!previewTest && remembered() && !active(swedishKey))) return;
  const alternate = document.querySelector('link[rel="alternate"][hreflang="sv"]');
  if (!alternate) return;
  let target;
  try {
    target = new URL(alternate.href, window.location.origin);
    if (target.origin !== window.location.origin) return;
    target.search = window.location.search;
    target.hash = window.location.hash;
    for (const name of ['locale', 'language', 'country', 'hk_language_test']) target.searchParams.delete(name);
  } catch (_) { return; }
  let returnTo = form.querySelector('[name="return_to"]');
  if (!returnTo) {
    returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    form.append(returnTo);
  }
  returnTo.value = target.pathname + target.search + target.hash;
  prompt.querySelectorAll('[data-hk-dismiss]').forEach(button => button.addEventListener('click', dismiss));
  prompt.addEventListener('keydown', event => { if (event.key === 'Escape') dismiss(); });
  form.addEventListener('submit', () => { remember(); saveSwedish(); });
  const show = country => {
    if (country !== 'SE') return;
    if (!previewTest && active(swedishKey)) {
      if (active(attemptKey)) return;
      let saved = false;
      for (const storage of stores()) {
        try { storage.setItem(attemptKey, String(Date.now() + 60000)); saved = true; } catch (_) {}
      }
      if (saved) HTMLFormElement.prototype.submit.call(form);
      return;
    }
    if (previewTest || !remembered()) prompt.hidden = false;
  };
  if (previewTest) {
    show('SE');
    return;
  }
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 5000);
  fetch((window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
    credentials: 'same-origin', signal: controller.signal
  })
    .then(response => { if (!response.ok) throw new Error('Localization unavailable'); return response.json(); })
    .then(data => show(data?.detected_values?.country?.handle))
    .catch(() => {})
    .finally(() => window.clearTimeout(timeout));
})();
